module.exports = __webpack_public_path__ + "media/images/dhl-2221568633faf48e2754b311886cf473.png";